module.exports = __webpack_public_path__ + "img/570.9a1a3c97.jpg";